import { useParams } from "@tanstack/react-router";
import { useMe } from "../../lib/me";

const KEY = "kwp.lastWorkspace";

/** Remembers the last workspace a person opened, per browser (a convenience only). */
export function rememberWorkspace(workspaceId: string): void {
  try {
    window.localStorage.setItem(KEY, workspaceId);
  } catch {
    // Storage can be unavailable (private mode); the app works without it.
  }
}

function lastWorkspace(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/**
 * Picks the workspace the shell shows: the one in the URL, else the last one opened (if the
 * person is still a member), else their first (Personal). Null only if they have none.
 */
export function pickWorkspace(
  workspaceIds: readonly string[],
  fromUrl: string | undefined,
  remembered: string | null,
): string | null {
  if (fromUrl !== undefined && workspaceIds.includes(fromUrl)) return fromUrl;
  if (remembered !== null && workspaceIds.includes(remembered)) return remembered;
  return workspaceIds[0] ?? null;
}

export function useCurrentWorkspaceId(): string | null {
  const me = useMe();
  const params = useParams({ strict: false });
  return pickWorkspace(
    me.workspaces.map((w) => w.id),
    params.workspaceId,
    lastWorkspace(),
  );
}
